/**
 * @file
 * Global Skazy skazy utilities.
 */


(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.skazy = {
    attach: function (context, settings) {
      _AddRow();
      _taxoDescriptionToggle();
    }
  };

  function _AddRow() {
   // Get the element with the class ".views-infinite-scroll-content-wrapper"
   var element = document.querySelector('.views-infinite-scroll-content-wrapper');

   // Add the "row" class to the element
     if (element) {
        element.classList.add('row', 'g-5');
      }
  }

  function _taxoDescriptionToggle() {
    $(document).ready(function () {
      // Cache selectors
      var $formCard = $('.b-form-card');
      var $activityCard = $('.b-activity-card');

      // Set margin-top based on presence of .b-form-card
      var marginValue = $(window).width() > 428 && $formCard.length > 0 ? $formCard.children().innerHeight() + 'px' : '30px';
      $activityCard.css('margin-top', marginValue);
    });
  }

})(jQuery, Drupal);

